export default __webpack_public_path__ + "static/studio-to-sea-banner-e6ea35dc078a2ffa95517a77667324dd.webp";